<template>
  <div>
    <register-credential-tef ref="RegisterCredentialTef"/>
    <register-bines-tef ref="RegisterBinesTef"/>
    <show-credentials-tef ref="ShowCredentialsTef"/>
  </div>
</template>

<script>

import RegisterCredentialTef from "@/views/app/administration/components/RegisterCredentialTef.vue";
import RegisterBinesTef from "@/views/app/administration/components/RegisterBinesTef.vue";
import ShowCredentialsTef from "@/views/app/administration/components/ShowCredentialTef.vue";

export default {
  components: {RegisterBinesTef, ShowCredentialsTef, RegisterCredentialTef}
}
</script>
